import { Stack, Typography } from '@mui/material';
import { join } from 'lodash';
import React from 'react';

export const PanelHeaderSummary = ({
  title,
  titleAction,
  markerNames,
  children,
}: {
  title: React.ReactNode;
  titleAction?: React.ReactNode;
  markerNames: string[];
  children?: React.ReactNode;
}) => (
  <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" alignItems="center" sx={{ minWidth: 0 }}>
    <Typography variant="subtitle1" fontWeight={600}>
      {title}
    </Typography>
    {titleAction}
    <Typography variant="body2" color="text.secondary">
      {join(markerNames, ', ')}
    </Typography>
    {children}
  </Stack>
);
